export const icons = {
  btc: "https://assets.coingecko.com/coins/images/1/small/bitcoin.png?1547033579",
  eth: "https://assets.coingecko.com/coins/images/279/small/ethereum.png?1595348880",
};
